import { createReducer } from '@reduxjs/toolkit'

import { keywordQueryFactTableColumnsConfig } from 'configuration/tables/searchTermsTable'
import { DATES, METRIC_FILTERS } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [METRIC_FILTERS],
        displayState: {
            [METRIC_FILTERS]: true,
        },
    },
    table: getDefaultTable(
        serializeColumns(keywordQueryFactTableColumnsConfig)
    ),
}

export default createReducer(initialState, () => {})
